export const DINHEIRO = '01';
export const CHEQUE = '02';
export const CARTAO_CREDITO = '03';
export const CARTAO_DEBITO = '04';
export const PRAZO = '05';
export const VALE_ALIMENTACAO = '10';
export const VALE_REFEICAO = '11';
export const VALE_PRESENTE = '12';
export const VALE_COMBUSTIVEL = '13';
export const BOLETO_BANCARIO = '15';
export const DEPOSITO_BANCARIO = '16';
export const PIX = '17';
export const TRANSF_BANCARIA = '18';
export const FIDELIDADE = '19';
export const NENHUM = '90';
export const PAGAMENTO_POSTERIOR = '91';
export const OUTROS = '99';
